export const RENDER_TYPE = Object.freeze({
  WORKKARD: "workkard",
  ACTIVITY: "activity",
  CONTACT: "contact",
});
